import { Errors } from "./errors";
import { showErrorToast } from "./toast";


export const onFetchError = (e) => {
	const error = Errors.treatError(e);
	showErrorToast(error.message);
};
